var fixHead = $('.header__pre-fix');

$(window).scroll(function () {
    if ($('html').hasClass('noScroll')) return;
    if ($(this).scrollTop() > 1) {
        fixHead.addClass("header__fix");
    } else {
        fixHead.removeClass("header__fix");
    }
});

if ($(window)[0].scrollY > 1) {
    fixHead.addClass("header__fix");
}

$('.header__burger ').on('click', e => {
    $('html').toggleClass('menu-is-open')
})